import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=45d73668&scoped=true&"
import script from "./TeamMemberList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberList.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberList.vue?vue&type=style&index=0&id=45d73668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d73668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d73668')) {
      api.createRecord('45d73668', component.options)
    } else {
      api.reload('45d73668', component.options)
    }
    module.hot.accept("./TeamMemberList.vue?vue&type=template&id=45d73668&scoped=true&", function () {
      api.rerender('45d73668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/TeamMemberList.vue"
export default component.exports